import React from "react";
import uuid from "react-uuid";
import { Container, Wrapper, Item, Video } from "./styles";

export const VideoGallery = ({ data, color }) => {
  return (
    <Container color={color}>
      <Wrapper>
        {data.map((video, i) => (
          <Item key={uuid()}>
            <Video src={video} muted loop autoPlay playsInline />
          </Item>
        ))}
      </Wrapper>
    </Container>
  );
};
